import { Box, Flex } from '@chakra-ui/react';
import { useGameColorsProvider } from 'src/providers/Theme/gameColorsProvider';
import { BuyStages } from '../getGame';

const BarItem = ({ completed }: { completed: boolean }) => {
	const { callToActionColor } = useGameColorsProvider();

	return (
		<Box
			h="4px"
			w="73px"
			border={`1px solid ${completed ? callToActionColor : '#B7B7B7'}`}
			borderRadius="4px"
			bg={completed ? callToActionColor : 'transparent'}
		/>
	);
};

export const LoadingBar = ({ stage }: { stage: BuyStages }) => {
	return (
		<Flex gridGap="8px">
			<BarItem completed={stage > BuyStages.NOT_STARTED} />
			<BarItem completed={stage > BuyStages.APPROVING} />
			<BarItem completed={stage > BuyStages.APPROVED} />
			<BarItem completed={stage > BuyStages.BUYING} />
		</Flex>
	);
};
